import lang from '@/lang/middleware/pages/price-change-calendar';
import { getRateChanges } from '@/graphql/queries/shared/rate-change';

export default async ({ $apolloQuery, route, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const description = store.$i18n.t('description');
  const title = store.$i18n.t('title');
  store.commit('pageContent/setHead', { description, title });

  const page = route.query.page;
  const product = route.query.product;
  await $apolloQuery(getRateChanges, { page, product }).then(r => {
    store.commit('search/set', { product });
    store.commit('rateChanges/set', r.changes);
    store.commit('rateChanges/setMeta', r.data);
  });
};
